import * as React from 'react';
import Tabs from '@material-ui/core/Tabs';

const CustomTabs = (props) => {
    return <Tabs {...props} />;
};

export { CustomTabs as Tabs };
